import React from 'react';
import './ui-components.scss'

const Spinner = () => {
    return (
        <div className="lds-dual-ring"></div>
    );
};

export default Spinner;